import React, { createContext, useState, useEffect } from "react";

// LIKE 1.3 MT
import like13mt1 from "../assets/img/landing-cronos/like-1-3-mt/1.png";
import like13mt2 from "../assets/img/landing-cronos/like-1-3-mt/2.png";
import like13mt3 from "../assets/img/landing-cronos/like-1-3-mt/3.png";
import like13mt4 from "../assets/img/landing-cronos/like-1-3-mt/4.png";
import like13mt5 from "../assets/img/landing-cronos/like-1-3-mt/5.png";
import like13mt6 from "../assets/img/landing-cronos/like-1-3-mt/6.png";
import like13mt7 from "../assets/img/landing-cronos/like-1-3-mt/7.png";

// DRIVE PLUS
import driveplus1 from "../assets/img/landing-cronos/drive-plus/1.png";
import driveplus2 from "../assets/img/landing-cronos/drive-plus/2.png";
import driveplus3 from "../assets/img/landing-cronos/drive-plus/3.png";
import driveplus4 from "../assets/img/landing-cronos/drive-plus/4.png";
import driveplus5 from "../assets/img/landing-cronos/drive-plus/5.png";
import driveplus6 from "../assets/img/landing-cronos/drive-plus/6.png";
import driveplus7 from "../assets/img/landing-cronos/drive-plus/7.png";

// STILE 1.3 MT
import stile13mt1 from "../assets/img/landing-cronos/stile-1-3-mt/1.png";
import stile13mt2 from "../assets/img/landing-cronos/stile-1-3-mt/2.png";
import stile13mt3 from "../assets/img/landing-cronos/stile-1-3-mt/3.png";
import stile13mt4 from "../assets/img/landing-cronos/stile-1-3-mt/4.png";
import stile13mt5 from "../assets/img/landing-cronos/stile-1-3-mt/5.png";
import stile13mt6 from "../assets/img/landing-cronos/stile-1-3-mt/6.png";
import stile13mt7 from "../assets/img/landing-cronos/stile-1-3-mt/7.png";

// PRECISIÓN
import precision1 from "../assets/img/landing-cronos/precision/1.png";
import precision2 from "../assets/img/landing-cronos/precision/2.png";
import precision3 from "../assets/img/landing-cronos/precision/3.png";
import precision4 from "../assets/img/landing-cronos/precision/4.png";
import precision5 from "../assets/img/landing-cronos/precision/5.png";
import precision6 from "../assets/img/landing-cronos/precision/6.png";
import precision7 from "../assets/img/landing-cronos/precision/7.png";

// FICHA TECNICA
import cronos_seguridad01 from "../assets/img/landing-cronos/ficha-tecnica/Cronos-Seguridad-01.png";
import cronos_seguridad02 from "../assets/img/landing-cronos/ficha-tecnica/Cronos-Seguridad-02.png";
import cronos_seguridad03 from "../assets/img/landing-cronos/ficha-tecnica/Cronos-Seguridad-03.png";
import cronos_seguridad04 from "../assets/img/landing-cronos/ficha-tecnica/Cronos-Seguridad-04.png";

import cronos_confort01 from "../assets/img/landing-cronos/ficha-tecnica/Cronos-Confort-01.png";
import cronos_confort02 from "../assets/img/landing-cronos/ficha-tecnica/Cronos-Confort-02.png";
import cronos_confort03 from "../assets/img/landing-cronos/ficha-tecnica/Cronos-Confort-03.png";
import cronos_confort04 from "../assets/img/landing-cronos/ficha-tecnica/Cronos-Confort-04.png";

//Crear el context
export const VehiculosContext = createContext();

//provider es donde se encuentran las funciones y state
const VehiculosProvider = (props) => {
  const [vehiculos, setVehiculos] = useState("LIKE 1.3 MT");

  const arrayVehiculos = [
    {
      id: "LIKE 1.3 MT",
      name: "LIKE 1.3 MT",
      img: [like13mt1, like13mt2, like13mt3, like13mt4, like13mt5, like13mt6, like13mt7],
      seguridad: [
        "2 Airbags (frontales conductor y pasajero)",
        "Alarma Perimetral ",
        "Apoyacabezas regulables en altura (5) ",
        "Cinturones de seguridad delanteros reg. en altura Cinturones de seguridad posteriores de 3 puntos ",
        "Control electrónico de traccion (TC) y estabilidad (ESC) ",
        "Inmovilizador de motor (Fiat Code) ",
        "Sensores de estacionamiento traseros ",
        "Sistema de asistencia al arranque en pendiente (HLA) ",
        "Sistema de frenos ABS + EBD Sistema de Monitoreo de Presión de Neumáticos (iTPMS) ",
        "Sistema de sujeción de sillas para niños (ISOFIX)",
      ],
      confort: [
        "Volante multifunción ",
        "Display multifunción 3,5",
        "Radio AM/FM integrada con USB entrada auxiliar y Bluetooth ",
        "Puerto USB (1) ",
        "Toma de 12V",
      ],
      seguridad23: [
        { foto: cronos_confort01, titulo: "2 Airbags (frontales conductor y pasajero)" },
        { foto: cronos_seguridad02, titulo: "Apoyacabezas regulables en altura" },
        { foto: cronos_seguridad03, titulo: "Sistema de frenos ABS + EBD " },
        { foto: cronos_seguridad04, titulo: "Sensores de estacionamiento traseros " },
      ],
      tecnologia23: [
        { foto: cronos_seguridad01, titulo: "Volante multifunción " },
        { foto: cronos_confort02, titulo: "Display multifunción 3,5'' " },
        { foto: cronos_confort03, titulo: "Radio AM/FM integrada con USB, entrada auxiliar y Bluetooth" },
        { foto: cronos_confort04, titulo: "Toma de 12V" },
      ],
    },
    {
      id: "Drive Plus 1.2 MT",
      name: "Drive Plus 1.2 MT",
      img: [driveplus1, driveplus2, driveplus3, driveplus4, driveplus5, driveplus6, driveplus7],
      seguridad: [
        "2 Airbags (frontales conductor y pasajero)",
        "Alarma Perimetral ",
        "Apoyacabezas regulables en altura (5) ",
        "Cinturones de seguridad delanteros reg. en altura Cinturones de seguridad posteriores de 3 puntos ",
        "Control electrónico de traccion (TC) y estabilidad (ESC) ",
        "Inmovilizador de motor (Fiat Code) ",
        "Sensores de estacionamiento traseros ",
        "Sistema de asistencia al arranque en pendiente (HLA)",
        "Sistema de frenos ABS + EBD Sistema de Monitoreo de Presión de Neumáticos (iTPMS) ",
        "Sistema de sujeción de sillas para niños (ISOFIX)2 Airbags (frontales conductor y pasajero)",
        "Alarma Perimetral ",
        "Apoyacabezas regulables en altura (5)",
        "Cinturones de seguridad delanteros reg. en altura Cinturones de seguridad posteriores de 3 puntos",
        "Control electrónico de traccion (TC) y estabilidad (ESC) ",
        "Inmovilizador de motor (Fiat Code) ",
        "Sistema de sujeción de sillas para niños (ISOFIX)",
      ],
      confort: [
        "Volante multifunción. ",
        "Display multifunción 3,5'",
        "Pantalla multimedia touch 7' con Android Auto y Apple Carplay.",
        "Puerto USB (2).",
        "Toma de 12V.",
      ],
      seguridad23: [
        { foto: cronos_confort01, titulo: "2 Airbags (frontales conductor y pasajero)" },
        { foto: cronos_seguridad02, titulo: "Apoyacabezas regulables en altura" },
        { foto: cronos_seguridad03, titulo: "Sistema de frenos ABS + EBD " },
        { foto: cronos_seguridad04, titulo: "Sensores de estacionamiento traseros " },
      ],
      tecnologia23: [
        { foto: cronos_seguridad01, titulo: "Volante multifunción " },
        { foto: cronos_confort02, titulo: "Display multifunción 3,5'' " },
        { foto: cronos_confort03, titulo: "Radio AM/FM integrada con USB, entrada auxiliar y Bluetooth" },
        { foto: cronos_confort04, titulo: "Toma de 12V" },
      ],
    },
    {
      id: "STILE 1.3 MT",
      name: "STILE 1.3 MT",
      img: [stile13mt1, stile13mt2, stile13mt3, stile13mt4, stile13mt5, stile13mt6, stile13mt7],
      seguridad: [
        "2 Airbags (frontales conductor y pasajero)",
        "Alarma Perimetral ",
        "Apoyacabezas regulables en altura (5) ",
        "Cinturones de seguridad delanteros reg. en altura Cinturones de seguridad posteriores de 3 puntos",
        "Control electrónico de traccion (TC) y estabilidad (ESC) ",
        "Inmovilizador de motor (Fiat Code) ",
        "Sensores de estacionamiento traseros ",
        "Sistema de asistencia al arranque en pendiente (HLA) ",
        "Sistema de frenos ABS + EBD Sistema de Monitoreo de Presión de Neumáticos (iTPMS)",
        "Sistema de sujeción de sillas para niños (ISOFIX)",
      ],
      confort: [
        "Volante multifunción. ",
        "Display multifunción 3,5'",
        "Pantalla multimedia touch 7' con Android Auto y Apple Carplay.",
        "Puerto USB (2).",
        "Toma de 12V.",
      ],
      seguridad23: [
        { foto: cronos_confort01, titulo: "2 Airbags (frontales conductor y pasajero)" },
        { foto: cronos_seguridad02, titulo: "Apoyacabezas regulables en altura" },
        { foto: cronos_seguridad03, titulo: "Sistema de frenos ABS + EBD " },
        { foto: cronos_seguridad04, titulo: "Sensores de estacionamiento traseros " },
      ],
      tecnologia23: [
        { foto: cronos_seguridad01, titulo: "Volante multifunción " },
        { foto: cronos_confort02, titulo: "Display multifunción 3,5'' " },
        { foto: cronos_confort03, titulo: "Radio AM/FM integrada con USB, entrada auxiliar y Bluetooth" },
        { foto: cronos_confort04, titulo: "Toma de 12V" },
      ],
    },
    {
      id: "Precision CVT",
      name: "Precision CVT",
      img: [precision1, precision2, precision3, precision4, precision5, precision6, precision7],
      seguridad: [
        "2 Airbags (frontales conductor y pasajero)",
        "Alarma Perimetral ",
        "Apoyacabezas regulables en altura (5) ",
        "Cinturones de seguridad delanteros reg. en altura Cinturones de seguridad posteriores de 3 puntos",
        "Control electrónico de traccion (TC) y estabilidad (ESC) ",
        "Inmovilizador de motor (Fiat Code) ",
        "Sensores de estacionamiento traseros",
        "Sistema de asistencia al arranque en pendiente (HLA) ",
        "Sistema de frenos ABS + EBD Sistema de Monitoreo de Presión de Neumáticos (iTPMS) ",
        "Sistema de sujeción de sillas para niños (ISOFIX)",
      ],
      confort: [
        "Volante multifunción. ",
        "Display multifunción 3,5'",
        "Pantalla multimedia touch 7' con Android Auto y Apple Carplay.",
        "Puerto USB (2).",
        "Modo SPORT.",
        "Toma de 12V.",
      ],
      seguridad23: [
        { foto: cronos_confort01, titulo: "2 Airbags (frontales conductor y pasajero)" },
        { foto: cronos_seguridad02, titulo: "Apoyacabezas regulables en altura" },
        { foto: cronos_seguridad03, titulo: "Sistema de frenos ABS + EBD " },
        { foto: cronos_seguridad04, titulo: "Sensores de estacionamiento traseros " },
      ],
      tecnologia23: [
        { foto: cronos_seguridad01, titulo: "Volante multifunción " },
        { foto: cronos_confort02, titulo: "Display multifunción 3,5'' " },
        { foto: cronos_confort03, titulo: "Radio AM/FM integrada con USB, entrada auxiliar y Bluetooth" },
        { foto: cronos_confort04, titulo: "Toma de 12V" },
      ],
    },
  ];

  const marcaLanding = "FIAT CRONOS";
  const modeloLanding = "";

  return (
    <VehiculosContext.Provider
      value={{
        vehiculos,
        setVehiculos,
        arrayVehiculos,
        marcaLanding,
        modeloLanding,
      }}
    >
      {props.children}
    </VehiculosContext.Provider>
  );
};

export default VehiculosProvider;
